module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_37.81d11f0e.jpeg";